import { Form, Link } from 'react-router'

interface LivestreamEntry {
	id: string
	slug: string
	youtubeId: string | null
	title: string
	publishedAt: string | Date
}

interface LivestreamStats {
	total: number
	streamsThisMonth: number
}

export function LivestreamGrid({
	livestreams,
	livestreamStats,
	searchQuery,
	showSearch = true,
}: {
	livestreams: LivestreamEntry[]
	livestreamStats: LivestreamStats
	searchQuery: string
	showSearch?: boolean
}) {
	return (
		<>
			<div className="flex flex-wrap items-center gap-6 mb-4">
				<div className="rounded-lg bg-cyan-100 dark:bg-cyan-900 px-4 py-2">
					<span className="text-2xl font-bold">{livestreamStats.streamsThisMonth}</span>
					<span className="ml-2 text-sm">this month</span>
				</div>
				<div className="rounded-lg bg-cyan-100 dark:bg-cyan-900 px-4 py-2">
					<span className="text-2xl font-bold">{livestreamStats.total}</span>
					<span className="ml-2 text-sm">total streams</span>
				</div>
				{showSearch && (
					<Form method="get" action="/livestreams" className="flex items-center gap-2">
						<input
							type="text"
							name="q"
							placeholder="Search streams..."
							defaultValue={searchQuery}
							className="rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-cyan-500 w-64"
						/>
						<button type="submit" className="rounded-lg bg-cyan-600 hover:bg-cyan-700 text-white px-3 py-2 text-sm transition-colors">Search</button>
						{searchQuery && (
							<Link to="/livestreams" className="text-sm text-gray-500 hover:underline">Clear</Link>
						)}
					</Form>
				)}
				{searchQuery && (
					<span className="text-sm text-gray-500">{livestreams.length} result{livestreams.length !== 1 ? 's' : ''}</span>
				)}
			</div>
			{livestreams.length > 0 ? (
				<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
					{livestreams.map((stream) => (
						<a
							key={stream.id}
							href={`https://www.youtube.com/watch?v=${stream.youtubeId}`}
							target="_blank"
							rel="noreferrer"
							className="flex flex-col rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden hover:shadow-lg transition-shadow"
						>
							<img
								src={`https://img.youtube.com/vi/${stream.youtubeId}/mqdefault.jpg`}
								alt={stream.title}
								className="w-full aspect-video object-cover"
							/>
							<div className="p-3">
								<p className="font-medium text-sm line-clamp-2">{stream.title}</p>
								<p className="text-xs text-gray-500 mt-1">
									{new Date(stream.publishedAt).toLocaleDateString('en-US', {
										weekday: 'short',
										month: 'short',
										day: 'numeric',
										year: 'numeric',
									})}
								</p>
							</div>
						</a>
					))}
				</div>
			) : searchQuery ? (
				<p className="text-gray-500">No streams matching "{searchQuery}"</p>
			) : (
				<p className="text-gray-500">No livestreams recorded yet. They will appear here as streams go live!</p>
			)}
		</>
	)
}
